import { render, staticRenderFns } from "./HistoricoCargos.vue?vue&type=template&id=e54120e0&"
import script from "./HistoricoCargos.vue?vue&type=script&lang=js&"
export * from "./HistoricoCargos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports